import { useState } from 'react'
import { router } from '@inertiajs/react'
import { PersonSummary } from '../../types'

interface Props {
  user: PersonSummary
  onClose: () => void
}

export default function DeactivateConfirmModal({ user, onClose }: Props) {
  const [submitting, setSubmitting] = useState(false)

  const handleDeactivate = () => {
    setSubmitting(true)
    router.post(`/people/${user.id}/deactivate`, {}, {
      onFinish: () => setSubmitting(false),
      onSuccess: () => onClose(),
    })
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-elevated w-full max-w-md mx-4">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full bg-[#B87A20]/10 flex items-center justify-center">
              <svg className="w-5 h-5 text-[#B87A20]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-text-primary font-heading">Deactivate User</h3>
              <p className="text-sm text-text-secondary">This action can be reversed</p>
            </div>
          </div>

          <p className="text-sm text-text-primary mb-2">
            Are you sure you want to deactivate <strong>{user.full_name}</strong>?
          </p>
          <ul className="text-sm text-text-primary space-y-1 mb-6 ml-4 list-disc">
            <li>They will be unable to sign in</li>
            <li>Their data will be preserved</li>
            <li>They can be reactivated at any time</li>
          </ul>

          <div className="flex justify-end gap-3">
            <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-text-primary hover:text-text-primary transition-colors">
              Cancel
            </button>
            <button
              onClick={handleDeactivate}
              disabled={submitting}
              className="px-5 py-2 bg-[#B87A20] text-white text-sm font-semibold rounded-lg hover:bg-[#B87A20]/90 transition-colors disabled:opacity-50"
            >
              {submitting ? 'Deactivating...' : 'Deactivate'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
